import { combineReducers } from 'redux';

import dashboard from '../individualPortal/dashboard/dashboardReducer';
import secureInbox from '../individualPortal/secureInbox/secureInboxReducer';
import ticketSahInfo from '../individualPortal/ticket/ticketConsumerInfoReducer';
import ticketFile from '../individualPortal/ticket/ticketFileReducer';
import ticket from '../individualPortal/ticket/ticketReducer';
import applications from './applications/applicationsReducer';
import communicationPreferences, * as fromCommunicationPreferences from './communicationPreferences/communicationPreferencesReducer';
import customGrouping from './customGrouping/customGroupingReducer';
import eligibilityResults from './eligibilityResults/eligibilityResultsReducer';
import enrollmentHistory from './enrollmentHistory/enrollmentHistoryReducer';
import planSummary from './planSummary/planSummaryReducer';
import memberHistoricalDocuments from './historicalDocuments/memberHistoricalDocumentsReducer';
import memberHistoricalNotices from './historicalNotices/memberHistoricalNoticesReducer';

export default combineReducers({
    dashboard,
    applications,
    communicationPreferences,
    eligibilityResults,
    secureInbox,
    ticket,
    ticketSahInfo,
    ticketFile,
    customGrouping,
    enrollmentHistory,
    planSummary,
    memberHistoricalDocuments,
    memberHistoricalNotices,
});

// Selectors

export const selectMailingAddressFromComPref =
    state => fromCommunicationPreferences.selectMailingAddressFromComPref(state.communicationPreferences);
export const selectIfCommunicationPreferencesLoaded =
    state => fromCommunicationPreferences.selectIfCommunicationPreferencesLoaded(state.communicationPreferences);
export const selectIfLanguagesLoaded = state => fromCommunicationPreferences.selectIfLanguagesLoaded(state.communicationPreferences);
export const selectCommunicationPreferences = state => state.communicationPreferences;